import { useQuery } from '@tanstack/react-query'
import { useStore } from 'react-redux'
import { getAttentionNeeded } from '@/common/src/actions/itemsAPI'
import { addMonths } from 'date-fns'

export const useAttentionNeededQuery = () => {
  const store = useStore()
  return useQuery({
    queryKey: ['attentionNeeded'],
    queryFn: () => {
      return store.dispatch(
        getAttentionNeeded({
          timestamp__gte: addMonths(new Date(), -2).toISOString(),
          add_mentions: true,
        })
      )
    },
    staleTime: 1000 * 60 * 5,
  })
}
